import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#default-value" }),
  /*#__PURE__*/_createTextVNode(" Default Value ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" If user hasn't picked a date, shows today's calendar by default. You can use "),
  /*#__PURE__*/_createVNode("code", null, "default-value"),
  /*#__PURE__*/_createTextVNode(" to set another date. Its value should be parsable by "),
  /*#__PURE__*/_createVNode("code", null, "new Date()"),
  /*#__PURE__*/_createTextVNode("."),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" If type is "),
  /*#__PURE__*/_createVNode("code", null, "daterange"),
  /*#__PURE__*/_createTextVNode(", "),
  /*#__PURE__*/_createVNode("code", null, "default-value"),
  /*#__PURE__*/_createTextVNode(" sets the left side calendar. ")
], -1)
const _hoisted_4 = { class: "rounded border p-10" }
const _hoisted_5 = { class: "block mb-5" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", {
  class: "demonstration",
  style: {"margin-right":"5px"}
}, "date", -1)
const _hoisted_7 = { class: "block" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", {
  class: "demonstration",
  style: {"margin-right":"5px"}
}, "daterange", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_el_date_picker, {
          modelValue: _ctx.value1,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.value1 = $event)),
          type: "date",
          placeholder: "Pick a date",
          "default-value": new Date(2010, 9, 1)
        }, null, 8, ["modelValue", "default-value"])
      ]),
      _createVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_el_date_picker, {
          modelValue: _ctx.value2,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.value2 = $event)),
          type: "daterange",
          align: "right",
          "start-placeholder": "Start Date",
          "end-placeholder": "End Date",
          "default-value": [new Date(2010, 9, 1), new Date(2010, 10, 1)]
        }, null, 8, ["modelValue", "default-value"])
      ]),
      _createVNode(_component_CodeHighlighter, {
        "field-height": "400",
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code5), 1)
        ]),
        _: 1
      })
    ])
  ]))
}